var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgI3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2003_10011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 24C5.9 24 0.5 18.6 0.5 12C0.5 5.4 5.9 0 12.5 0C19.1 0 24.5 5.4 24.5 12C24.5 18.6 19.1 24 12.5 24ZM12.5 1.2C6.56 1.2 1.7 6.06 1.7 12C1.7 17.94 6.56 22.8 12.5 22.8C18.44 22.8 23.3 17.94 23.3 12C23.3 6.06 18.44 1.2 12.5 1.2Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.52 14.4591L16.1 9.41908C16.34 9.17908 16.04 9.11908 15.74 9.29908L8.89999 13.6191L5.96 12.7191C5.3 12.5391 5.3 12.0591 6.08 11.7591L17.66 7.31908C18.2 7.07908 18.68 7.43908 18.5 8.27908L16.52 17.5791C16.4 18.2391 15.98 18.4191 15.44 18.1191L12.44 15.8991L11 17.2791C10.82 17.4591 10.58 17.4591 10.58 17.2791L10.52 14.4591Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2003_10011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgI3);
export default __webpack_public_path__ + "static/media/i3.19d836066c664656468e90db8ae68995.svg";
export { ForwardRef as ReactComponent };